module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    class: _vm.iconClass,
    attrs: {
      "viewBox": _vm.icon.viewBox,
      "width": _vm.width,
      "height": _vm.height
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": ("#" + (_vm.icon.id))
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-391bcc9d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/common/svgIcon/SvgIcon.vue
// module id = 1860
// module chunks = 0